import { render } from "./Userinfo-Item.vue?vue&type=template&id=7929bc65"
import script from "./Userinfo-Item.vue?vue&type=script&lang=js"
export * from "./Userinfo-Item.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__